@if (selectedAddressId) {
    <div class="container-address pl-4 pr-4 pb-4 pt-0">
        <p>{{ getAddress(selectedAddressId)?.gesoftName1 }}</p>
        <p>{{ getAddress(selectedAddressId)?.gesoftName2 }}</p>
        <p>{{ getAddress(selectedAddressId)?.street }}</p>
        <p>{{ getAddress(selectedAddressId)?.postcode }} {{ getAddress(selectedAddressId)?.town }}</p>
    </div>
}
<iw-shop-forms-error [apiError]="apiError"></iw-shop-forms-error>
<div class="tabs">
    <ul>
        @if (selectedAddressId && hasLoggedInUserAccessToEditAddresses()) {
            <li (click)="activeTab = 'updateAddress'; fillFormWithAddress(selectedAddressId)"
                [ngClass]="activeTab == 'updateAddress' ? 'is-active': ''"><a>Adresse bearbeiten</a></li>
        }
        @if ((isAddressOverview && addresses.length > 1)) {
            <li (click)="activeTab = 'addresses'" [ngClass]="activeTab == 'addresses' ? 'is-active': ''"><a>Adressen</a>
            </li>
        }

        @if (isSelectAddress && addresses.length > 0) {
            <li (click)="activeTab = 'selectAddress'"
                [ngClass]="activeTab == 'selectAddress' ? 'is-active': ''"><a>Adresse wählen</a></li>
        }

        @if (hasLoggedInUserAccessToEditAddresses()) {
            <li (click)="activeTab = 'newAddress'; resetForm()"
                [ngClass]="activeTab == 'newAddress' ? 'is-active': ''"><a>Neue
                Adresse </a></li>
        }
    </ul>
</div>
@if (activeTab == 'newAddress' || activeTab == 'updateAddress') {
    <div>
        <div [formGroup]="form">
            <div class="columns mb-0">
                <div class="column py-2">
                    <div class="field  is-flex-grow-1" [ngClass]="isHidden('salutation')? 'is-hidden': ''">

                        <label class="label">
                            Anrede
                            @if (isRequired('salutation')) {
                                <span>*</span>
                            }
                        </label>

                        <div class="control">
                            <div class="select" [ngClass]="isFormRequestError('salutation') ? 'is-danger' : ''">
                                <select formControlName="salutation">
                                    <option [value]="null">Bitte auswählen</option>
                                    <option value="Frau">Frau</option>
                                    <option value="Herr">Herr</option>
                                    <option value="Divers">Divers</option>
                                </select>
                            </div>
                            @if (isFormRequestError('salutation')) {
                                <p class="help is-danger">{{ this.getFieldErrorMsg('salutation', 'Bitte hinterlegen Sie eine Anrede.') }}</p>
                            }
                        </div>
                    </div>
                </div>
                <div class="column py-2">

                    <div class="field  is-flex-grow-1" [ngClass]="isHidden('type')? 'is-hidden': ''">
                        <label class="label">
                            Adresstyp
                            @if (isRequired('type')) {
                                <span>*</span>
                            }
                        </label>
                        <div class="control">
                            <div class="select" [ngClass]="isFormRequestError('type') ? 'is-danger' : ''">
                                <select formControlName="type">
                                    <option value="">Rechnungs- & Lieferadresse</option>
                                    <option value="billing">Rechnungsadresse</option>
                                    <option value="delivery">Lieferadresse</option>
                                </select>
                            </div>
                            @if (isFormRequestError('type')) {
                                <p class="help is-danger">{{ this.getFieldErrorMsg('salutation', 'Bitte hinterlegen Sie einen Adresstyp.') }}</p>
                            }

                        </div>
                    </div>
                </div>
            </div>
            <div class="is-flex-tablet">
                <div class="field is-flex-grow-1" [ngClass]="isHidden('firstName')? 'is-hidden': ''">

                    <label class="label">
                        Vorname
                        @if (isRequired('firstName')) {
                            <span>*</span>
                        }
                    </label>


                    <div class="control">
                        <input formControlName="firstName"
                               [ngClass]="isFormRequestError('firstName') ? 'is-danger' : ''" class="input"
                               type="text"
                               placeholder="Vorname"/>
                        @if (isFormRequestError('firstName')) {
                            <p class="help is-danger">{{ this.getFieldErrorMsg('firstName', 'Bitte hinterlegen Sie einen Vornamen.') }}</p>
                        }

                    </div>
                </div>
                <div class="field is-flex-grow-1 ml-4-desktop" [ngClass]="isHidden('name')? 'is-hidden': ''">

                    <label class="label">Nachname
                        @if (isRequired('name')) {
                            <span>*</span>
                        }
                    </label>
                    <div class="control">
                        <input formControlName="name" [ngClass]="isFormRequestError('name') ? 'is-danger' : ''"
                               class="input" type="text"
                               placeholder="Nachname"/>
                        @if (isFormRequestError('name')) {
                            <p class="help is-danger">{{ this.getFieldErrorMsg('name', 'Bitte hinterlegen Sie einen Namen.') }}</p>
                        }
                    </div>
                </div>
            </div>
            <div class="field" [ngClass]="isHidden('company')? 'is-hidden': ''">
                <label class="label">Firma
                    @if (isRequired('company')) {
                        <span>*</span>
                    }
                </label>
                <div class="control">
                    <input formControlName="company" class="input" type="text" placeholder="Firma" value=""/>
                </div>
            </div>
            <div class="field" [ngClass]="isHidden('street')? 'is-hidden': ''">
                <label class="label">
                    Straße und Hausnummer
                    @if (isRequired('street')) {
                        <span>*</span>
                    }
                </label>
                <div class="control">
                    <input formControlName="street" [ngClass]="isFormRequestError('street') ? 'is-danger' : ''"
                           class="input" type="text"
                           placeholder="Straße und Hausnummer" value=""/>
                    @if (isFormRequestError('street')) {
                        <p class="help is-danger">{{ this.getFieldErrorMsg('street', 'Bitte hinterlegen Sie eine Straße und Hausnummer.') }}
                            .</p>
                    }

                </div>
            </div>
            <div class="is-flex-tablet">
                <div class="field is-flex-grow-1" [ngClass]="isHidden('postcode')? 'is-hidden': ''">
                    <label class="label">Postleitzahl
                        @if(isRequired('postcode')){
                            <span>*</span>
                        }

                    </label>
                    @if(getDeliveryPostcodesGroup().length > 0 && isDeliveryAddress()){
                        <div class="select"
                             [ngClass]="isFormRequestError('postcode') ? 'is-danger' : ''">
                            <select formControlName="postcode">
                                <option [value]="''">Bitte auswählen</option>
                                @for (postcode of getDeliveryPostcodesGroup(); track postcode) {
                                    <option [value]="postcode">{{ postcode }}</option>
                                }
                            </select>
                        </div>
                    }
                    @if(getDeliveryPostcodesGroup().length <= 0 || !isDeliveryAddress()){
                        <div class="control">
                            <input formControlName="postcode"
                                   [ngClass]="isFormRequestError('postcode') ? 'is-danger' : ''"
                                   class="input" type="text"
                                   placeholder="Postleitzahl" value=""/>
                            @if(isFormRequestError('postcode')){
                                <p
                                        class="help is-danger">{{ this.getFieldErrorMsg('postcode', 'Bitte hinterlegen Sie eine Postleitzahl.') }}
                                    .</p>
                            }
                        </div>
                    }

                </div>
                <div class="field is-flex-grow-1 ml-4-tablet" [ngClass]="isHidden('town')? 'is-hidden': ''">
                    <label class="label">Ort
                        @if(isRequired('town')){
                            <span>*</span>
                        }
                    </label>
                    @if(getDeliveryPostcodesGroup().length > 0 && isDeliveryAddress()){
                        @if(getDeliveryTownsByPostcode(form.get('postcode')?.value ?? '').length <= 0){
                            <p>Bitte Postleitzahl auswählen</p>
                        }
                        @if(getDeliveryTownsByPostcode(form.get('postcode')?.value ?? '').length > 0){
                            <div
                                    class="select"
                                    [ngClass]="isFormRequestError('town') ? 'is-danger' : ''">
                                <select formControlName="town">
                                    <option [value]="''">Bitte auswählen</option>
                                    @for (town of getDeliveryTownsByPostcode(form.get('postcode')?.value ?? ''); track town) {
                                        <option [value]="town">{{ town }}</option>
                                    }
                                </select>
                            </div>
                        }

                    }
                    @if(getDeliveryPostcodesGroup().length <= 0 || !isDeliveryAddress()){
                        <div class="control">
                            <input formControlName="town" [ngClass]="isFormRequestError('town') ? 'is-danger' : ''"
                                   class="input"
                                   type="text"
                                   placeholder="Ort" value=""/>

                        </div>
                    }
                    @if(isFormRequestError('town')){
                        <p
                                class="help is-danger">{{ this.getFieldErrorMsg('town', 'Bitte hinterlegen Sie einen Ort.') }}
                            .</p>
                    }
                </div>
            </div>
            <div class="field" [ngClass]="isHidden('phone')? 'is-hidden': ''">

                <label class="label">Telefon
                    @if(isRequired('phone')){
                        <span>*</span>
                    }
                </label>
                <div class="control">
                    <input formControlName="phone" [ngClass]="isFormRequestError('phone') ? 'is-danger' : ''"
                           class="input" type="tel"
                           placeholder="Telefon" value=""/>
                    @if(isFormRequestError('phone')){
                        <p
                                class="help is-danger">{{ this.getFieldErrorMsg('phone', 'Bitte hinterlegen Sie einen Telefonnummer.') }}</p>
                    }

                </div>
            </div>
            <div class="is-flex-tablet">
                <div class="field is-flex-grow-1 pr-2-tablet" [ngClass]="isHidden('floor')? 'is-hidden': ''">

                    <label class="label">Etage
                        @if(isRequired('floor')){
                            <span>*</span>
                        }
                    </label>
                    <div class="control">
                        <input formControlName="floor"
                               [ngClass]="isFormRequestError('floor') ? 'is-danger' : ''"
                               class="input" type="number"
                               placeholder="Etage" value="0"/>
                        @if(isFormRequestError('floor')){
                            <p class="help is-danger">{{ this.getFieldErrorMsg('floor', 'Bitte hinterlegen Sie Etage.') }}</p>
                        }

                    </div>
                </div>
                <div class="field is-flex-grow-1 ml-4-tablet" [ngClass]="isHidden('elevator')? 'is-hidden': ''">
                    <label class="label">Aufzug
                        @if(isRequired('elevator')){
                            <span>*</span>
                        }
                    </label>
                    <div class="control">
                        <div class="select" [ngClass]="isFormRequestError('elevator') ? 'is-danger' : ''">
                            <select formControlName="elevator">
                                <option [value]="null">Bitte auswählen</option>
                                <option [value]="true">Ja</option>
                                <option [value]="false">Nein</option>
                            </select>
                        </div>
                        @if(isFormRequestError('elevator')){
                            <p class="help is-danger">{{ this.getFieldErrorMsg('elevator', 'Bitte geben Sie an, ob Sie über einen Aufzug verfügen.') }}</p>
                        }

                    </div>
                </div>
            </div>
            <div class="field" [ngClass]="isHidden('country')? 'is-hidden': ''">
                <label class="label">Land
                    @if(isRequired('country')){
                        <span>*</span>
                    }
                </label>
                <div class="control">
                    <div class="select" [ngClass]="isFormRequestError('country') ? 'is-danger' : ''">
                        <select formControlName="country">
                            <option [value]="null">Bitte auswählen</option>
                            @for (country of countries; track country) {
                                <option [value]="country">{{ country }}</option>
                            }
                        </select>
                    </div>
                    @if(isFormRequestError('country')){
                        <p
                                class="help is-danger">{{ this.getFieldErrorMsg('country', 'Bitte hinterlegen Sie ein Land.') }}
                            .</p>
                    }

                </div>
            </div>
            <div class="mt-4">
                @if(hasAnyRequiredFields()){
                    <iw-shop-forms-submit-button [formStatus]="getFormStatus()"
                                                 [submitLabel]="activeTab == 'updateAddress' ? 'Adresse aktualisieren' : 'Adresse erfassen'"
                                                 (submit)="updateAddresses()"></iw-shop-forms-submit-button>
                }
            </div>
        </div>
    </div>
}
@if((addresses.length > 0 &&  (activeTab == 'selectAddress' || activeTab == 'addresses')) ){
    <div>
        @for (address of addresses; track address.addressId) {
            @if(hasUserAccessForCustomerAddress(address.addressId ?? '')){
                <div class="container-address p-4">
                    <div>
                        <div class="is-flex" [ngClass]="activeTab == 'selectAddress' ? 'select-address' : ''">
                            <div>
                                <button class="button" (click)="setSelectAddress(address.addressId ?? '')">Auswählen</button>
                            </div>
                            <div class="address is-flex-grow-1 ml-4 pb-4">
                                <div>
                                    <p>{{ address.gesoftName1 }}</p>
                                    <p>{{ address.gesoftName2 }}</p>
                                    <p>{{ address.street }}</p>
                                    <p>{{ address.postcode }} {{ address.town }}</p>
                                    @if(address.elevator || address.floor !== undefined){
                                        <p>
                                            @if(address.floor){
                                                <span>Etage: {{ address.floor }}</span>
                                            }
                                            @if(address.floor !== undefined){
                                                <span>
                                                Aufzug:
                                                    @if(address.elevator){
                                                        <span>Ja</span>
                                                    }
                                                    @if(!address.elevator){
                                                        <span>Nein</span>
                                                    }

                                            </span>
                                            }

                                        </p>
                                    }

                                </div>
                            </div>
                            @if(!selectedCustomer?.guest){
                                <div>
                                    @if(addresses.length > 1 && hasLoggedInUserAccessToEditAddresses()){
                                        <button class="delete" (click)="deleteAddress(address.addressId ?? '')"></button>
                                    }
                                </div>
                            }


                        </div>
                        <div class="columns">
                            <div class="column">
                                @if(!selectedCustomer?.guest){
                                    <div class="mt-2">
                                        <iw-shop-forms-submit-button [formStatus]="getFormStatus(address.addressId)" classes=""
                                                                     [submitLabel]="submitLabelDefaultAddress"
                                                                     (submit)="setDefaultAddress(address.addressId ?? '');"></iw-shop-forms-submit-button>
                                    </div>
                                }


                            </div>
                            <div class="column">
                                @if(hasLoggedInUserAccessToEditAddresses()){
                                    <button (click)="activeTab = 'updateAddress'; fillFormWithAddress(address.addressId ?? '')"
                                            class="button mt-2">Adresse bearbeiten
                                    </button>
                                }

                            </div>
                        </div>
                        @if(activeTab!='selectAddress'){
                            <p class="has-text-right">*Erforderlich</p>
                        }
                    </div>
                </div>
            }
        }
    </div>
}





